import React, { useEffect, useState, useRef } from "react";
import LoadingOverlay from "react-loading-overlay";
import { AgGridReact } from "ag-grid-react";
import { shallowEqual, useSelector } from "react-redux";
import ErrorContainer from "../../../Common/Errors/ErrorContainer";
import Cookies from "js-cookie";
import SendEmailRenderer from "../Renderers/SendEmailRenderer";

import {
  httpGetDBMMEBSubmittedSendEmail,
  httpPosttDBMMEBSubmittedSendEmail,
} from "../../../../service/httpClient";
import * as Constants from "../../../../constants/Constants";
import "./MBEApproval.css";

const MBESendEmail = () => {
  const gridRef = useRef();

  const [responseData, setResponseData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [updateStatus, setUpdateStatus] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [errorStatus, setErrorStatus] = useState(false);
  const resetErroMessage = () => {
    setErrorMsg("");
    setErrorStatus(false);
    setUpdateStatus(false);
    setSuccessMsg("");
  };

  const sendEmaiDetail = (data) => {
    const { vendorId, ceoEmail } = data;
    httpPosttDBMMEBSubmittedSendEmail(vendorId, Constants.DEI_TYPE, ceoEmail)
      .then((response) => {
        setErrorMsg("");
        setErrorStatus(false);
        setUpdateStatus(true);
        setSuccessMsg(Constants.MBE_WBE_SEND_MAIL_SUCCESS_MESSAGE);
        setTimeout(() => {
          resetErroMessage();
        }, 5000);
      })
      .catch((err) => {
        setErrorMsg(err.message);
        setErrorStatus(true);
        setUpdateStatus(false);
        setSuccessMsg("");
      });
  };
  const columnDefs = [
    {
      headerName: " ",
      field: "vendorId", //vendorProfileId
      width: 40,
      filter: false,
      sortable: false,
      hide: true,
    },
    {
      headerName: "Vendor Name",
      field: "vendorName",

      flex: 1,
      comparator: stringDataComparator,
    },

    {
      headerName: "Duns #",
      field: "duns",
      flex: 1,
      comparator: stringNumericDataComparator,
    },
    {
      headerName: "Created Date",
      field: "createdDate",
      flex: 1,
      width: 180,
    },
    {
      headerName: "Send Email",
      field: "sendEmail",
      width: 160,
      sortable: false,
      filter: false,
      cellRendererFramework: SendEmailRenderer,
      cellRendererParams: {
        sendEmaiDetail: sendEmaiDetail,
      },
    },
  ];
  const defaultColDef = {
    lockVisible: true,
    suppressMovable: true,
    enablePivot: true,
    filter: true,
    sortable: true,
    resizable: true,
  };
  function stringDataComparator(valueA, valueB) {
    const valueALower =
      valueA && valueA !== "" ? valueA.toLowerCase().trim() : valueA;
    const valueBLower =
      valueB && valueB !== "" ? valueB.toLowerCase().trim() : valueB;
    if (valueALower && valueBLower) {
      return valueALower === valueBLower
        ? 0
        : valueALower.localeCompare(valueBLower, "en", { numeric: true });
    } else if (valueALower && (valueBLower === null || valueBLower === "")) {
      return -1;
    } else if ((valueALower === null || valueALower === "") && valueBLower) {
      return 1;
    } else {
      return -1;
    }
  }
  function stringNumericDataComparator(valueA, valueB) {
    const valueALower =
      valueA && valueA !== "" ? valueA.toLowerCase().trim() : valueA;
    const valueBLower =
      valueB && valueB !== "" ? valueB.toLowerCase().trim() : valueB;
    if (valueALower && valueBLower) {
      if (!isNaN(valueALower) && !isNaN(valueBLower)) {
        return parseInt(valueALower, 10) === parseInt(valueBLower, 10)
          ? 0
          : parseInt(valueALower, 10) > parseInt(valueBLower, 10)
          ? 1
          : -1;
      } else if (isNaN(valueALower) && !isNaN(valueBLower)) {
        return 1;
      } else if (!isNaN(valueALower) && isNaN(valueBLower)) {
        return -1;
      } else {
        return valueALower === valueBLower
          ? 0
          : valueALower.localeCompare(valueBLower, "en", { numeric: true });
      }
    } else if (valueALower && (valueBLower === null || valueBLower === "")) {
      return -1;
    } else if ((valueALower === null || valueALower === "") && valueBLower) {
      return 1;
    } else {
      return -1;
    }
  }

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    httpGetDBMMEBSubmittedSendEmail(Cookies.get("email"), Constants.DEI_TYPE)
      .then((response) => {
        const { data = [], status } = response || {};

        if (data && data?.length > 0 && status === 200) {
          setResponseData(data);
          setIsLoading(false);
        } else {
          setResponseData([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  };

  return (
    <div className="mbeApproval">
      <div className="m-top-10">
        <ErrorContainer
          errorMsg={errorMsg}
          updateStatus={updateStatus}
          successMsg={successMsg}
          errorStatus={errorStatus}
          errorStyle="errorMessage"
          successStyle="successMessage"
        />
      </div>
      <LoadingOverlay active={isLoading} spinner>
        <div className="mbeApprovalHeading">
          {Constants.MY_VENDORS} ({responseData && responseData?.length})
        </div>

        <div className="ag-theme-balham mbeApprovalTable">
          <AgGridReact
            ref={gridRef}
            columnDefs={columnDefs}
            rowData={responseData}
            defaultColDef={defaultColDef}
            rowSelection="single"
            paginationPageSize="20"
            enableRangeSelection={true}
            pagination={true}
            overlayNoRowsTemplate={
              responseData.length > 0 ? "" : "No MBE/WBE pending request."
            }
          />
        </div>
      </LoadingOverlay>
    </div>
  );
};

export default MBESendEmail;
